import React from 'react';
import styled from 'astroturf/react';

import { Instructor as Props } from '../../shared/course_helper';

const Heading = styled.h5`
  @import '../../shared/mixins.scss';
  @include headingH5();
  @include textSecondary();
  margin-top: 0;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const Name = styled.h4`
  @import '../../shared/mixins.scss';
  @include bodyLargeBold();
  @include textSecondary();
  margin-top: 0;
  margin-bottom: 12px;
`;

const Description = styled.p`
  @import '../../shared/mixins.scss';
  @include bodyMediumRegular();
  @include textPrimary();
  white-space: pre-wrap;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  font-size: 13px;
  line-height: 15px;
  color: #b1ceff;
  a {
    margin-bottom: 8px;
  }
`;

const Instructor: React.FunctionComponent<Props> = ({
  name,
  description,
  links,
}) => (
  <>
    <Heading>Instructor</Heading>
    <Name>{name}</Name>
    <Description>{description}</Description>
    {links && (
      <LinksContainer>
        {links.map((link) => (
          <a
            key={link.url}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.name}
          </a>
        ))}
      </LinksContainer>
    )}
  </>
);

export default Instructor;
